import { lazy } from 'react'

import { EDIT_URL } from '../constants'

const EditScreen = lazy(
  /* istanbul ignore next */
  () => import(/* webpackChunkName: 'teams' */ '../screens/Edit'),
)

export default [
  {
    component: EditScreen,
    path: EDIT_URL,
  },
]
